import apiClient from './axios';

/**
 * Result of a bill service-address backfill run.
 *
 * A dry run reports only the first two counts — it never calls the bills
 * provider, so it is the safe way to size the job before authorising it.
 */
export interface BillAddressBackfillResult {
  dryRun: boolean;
  /** Distinct meters still missing an address. */
  metersPending: number;
  /** Bill rows those meters account for — one lookup can fill many. */
  rowsPending: number;
  metersAttempted: number;
  metersFilled: number;
  rowsUpdated: number;
  metersFailed: number;
  failures: Array<{ billerId: string; reason: string }>;
}

export const billsApi = {
  /**
   * Fill missing service addresses on historic bill payments.
   *
   * Defaults to a dry run on the server too, so an accidental call costs
   * nothing. `limit` caps how many distinct meters one run will look up.
   */
  async backfillAddresses(params: {
    dryRun: boolean;
    limit?: number;
  }): Promise<BillAddressBackfillResult> {
    const res = await apiClient.post('/admin/bills/backfill-addresses', params);
    return res.data.data;
  },
};
